import React from 'react';

const PHEDThresholdTravelTime = ({
  data: { thresholdTravelTime }
}) => (thresholdTravelTime ? <p>{`${thresholdTravelTime} sec`} </p> : null);

export default PHEDThresholdTravelTime;
